import React from "react";

import { constantsData } from "@/data";
import { OfflineView } from "@/views";

class NetworkErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = { hasError: false };
    }

    static getDerivedStateFromError(err) {
        const isNetworkError =
            constantsData.networkErrorPatterns.some((pattern) => err?.message?.includes(pattern)) ||
            err?.name === constantsData.chunkLoadError;

        return isNetworkError ? { hasError: true } : null;
    }

    render() {
        if (this.state.hasError) return <OfflineView />;

        return this.props.children;
    }
}

export default NetworkErrorBoundary;
